/* --------------------------------------------------------------------------------------------------
   Consors-Finanz-Widget (App-Embed) nachbessern
   --------------------------------------------------------------------------------------------------
   Das Widget auf der PDP wird komplett vom App-Embed "liquid-cf-do" per JS erzeugt und in
   .product-info__price (vor <financing-info>) bzw. hinter die Buy-Buttons eingehaengt:

     <div class="calculatorContainer" data-cf-pos="top|bottom">
       <div class="financingInfoWrapper">
         <img class="financingLogo">
         <div class="rateDetailsText">
           <button class="btn calcBtn openModalCalc">Finanzieren ab <strong>55,43€ / Monat</strong></button>
         </div>
       </div>
     </div>

   Der Markup ist app-seitig, also nicht im Theme editierbar. Zwei Dinge korrigieren wir hier:

   1) KLICKFLAECHE: Der App-Listener prueft `event.target.matches('.openModalCalc')`. Der Betrag liegt
      aber in einem <strong> INNERHALB des Buttons - ein Klick darauf (oder auf Logo/Flaeche) hat als
      target das <strong> bzw. den Wrapper und oeffnet den Rechner nie. Das Element sieht aber wie ein
      zusammenhaengender Link aus. Wir oeffnen das Modal deshalb fuer Klicks auf das gesamte Element.

   2) REIHENFOLGE: "Finanzieren ab 55,43€ / Monat" -> "Ab 55,43€ / Monat finanzieren", und das Logo
      wandert vom Anfang ans Ende der Zeile.

   3) HEADING-EBENE: Der serverseitige Teil des App-Embeds (Modal, Drawer, Overlay) steht auf JEDER
      Seite direkt vor </body> - Startseite, Kollektion, Warenkorb, PDP, und auch auf .com, wo das
      Widget nur per CSS ausgeblendet ist. Darin steckt

        <h1 class="modal_title">Ihr moeglicher Finanzierungsplan<sup>1</sup></h1>

      Damit hat jede Seite eine zweite <h1> neben der eigentlichen Seitenueberschrift. Wir ersetzen sie
      durch ein <p>. Bewusst kein <h2>: der Text ist inhaltlich keine Gliederungsebene der Seite,
      sondern die Beschriftung eines Dialogs - als Heading wuerde er in jedem Audit weiterhin in der
      Ueberschriften-Struktur auftauchen, nur eine Stufe tiefer.

      Die Optik bleibt identisch: die App-eigene Regel .modal_title ist rein klassenbasiert und setzt
      font-size, font-weight, line-height UND margin-top/-bottom selbst - die Default-Margins, die ein
      <p> vom Browser mitbringt, sind damit ueberschrieben. Weder consors-product.js noch die beiden
      App-Stylesheets sprechen h1 oder p an.

      ACHTUNG: Das repariert nur das gerenderte DOM. Im ausgelieferten Quelltext steht die <h1>
      weiterhin - Crawler mit JS-Rendering (u.a. Google) sehen die Korrektur, ein reiner
      Quelltext-Audit nicht. Die echte Loesung ist eine Zeile im App-Extension-Block der App
      "liquid-cf-do"; bis die kommt, ist das hier die Ueberbrueckung.

      Der Dialog verliert damit seine programmatische Beschriftung. Praktisch aendert das nichts: das
      Modal zeigt ohnehin auf aria-labelledby="exampleModalCenterTitle", eine ID, die es im Dokument
      nicht gibt - die Verknuepfung war also von Anfang an kaputt. Wer sie herstellen will, macht das
      in der App, zusammen mit dem Tag.

   4) ANREDE: Der Hinweis ab App-Version liquid-cf-do-17 (.cf-pdp-teaser) siezt, der Shop duzt. Ersetzt wird nur
      exakt der bekannte Wortlaut. Der Warnhinweis bleibt unangetastet. Aendert die App ihren Text, bleibt ihrer stehen.

   GELTUNGSBEREICH: (1), (2) und (4) veraendern das Widget selbst und laufen deshalb NUR dort, wo Consors
   auch angeboten wird - der Marktcheck aus layout/theme.liquid wird per data-Attribut am <script>-Tag
   hereingereicht. (3) laeuft dagegen ueberall, denn die <h1> steckt auf jeder Domain und jeder Seite
   im DOM, auch da, wo das Widget komplett ausgeblendet ist.

   Auf .com passiert damit nichts Consors-bezogenes: kein Label-Umbau, kein Logo-Verschieben, kein
   Klick-Listener. Das Widget bleibt dort ausgeblendet, wie es der <style>-Block im <head> vorgibt -
   das Skript kann es weder einblenden noch oeffnen.

   Alles laeuft ueber den vom App-Embed erzeugten DOM, wir aendern nichts an dessen Logik. Sollte die
   App ihr Markup umbauen, greifen die Selektoren einfach nicht mehr - das Widget faellt dann auf sein
   Originalverhalten zurueck.
   -------------------------------------------------------------------------------------------------- */
(function () {
  if (window.__llConsorsWidgetInit) return;
  window.__llConsorsWidgetInit = true;

  /* Marktcheck aus dem Theme (siehe ll_consors_enabled in layout/theme.liquid). Fehlt das Tag oder das
     Attribut, gilt bewusst "aus": lieber verzichten wir auf die beiden kosmetischen Korrekturen, als
     dass auf einer Domain ohne Consors-Angebot ein Klick-Listener fuer den Rechner haengt. */
  var configTag = document.getElementById('ll-consors-widget');
  var WIDGET_ENABLED = !!configTag && configTag.getAttribute('data-widget-enabled') === 'true';

  var CONTAINER_SELECTOR = '.calculatorContainer';
  var BUTTON_SELECTOR = '.openModalCalc';
  var WRAPPER_SELECTOR = '.financingInfoWrapper';
  var TEASER_SELECTOR = '.cf-pdp-teaser';

  /* Beide Wege auf dieselbe Ueberschrift: ueber die Klasse und ueber den Block-Wrapper des App-Embeds
     (dessen ID auf den Block-Key aus config/settings_data.json endet, gleicher Selektor wie im
     <style> in layout/theme.liquid). Faellt eine der beiden Kennungen bei einem App-Update weg,
     greift die andere - und kommt im Block eine weitere <h1> dazu, ist sie ebenfalls abgedeckt. */
  var HEADING_SELECTOR = 'h1.modal_title, [id$="__3703644428312960334"] h1';

  /* "Finanzieren ab <strong>55,43€ / Monat</strong>" -> "<strong>Ab 55,43€ / Monat</strong> finanzieren" */
  function swapLabel(button) {
    if (!button || button.dataset.llLabelSwapped) return;

    var strong = button.querySelector('strong');
    if (!strong) return;

    var rate = strong.textContent.trim();
    if (!rate) return;

    var rateElement = document.createElement('strong');
    rateElement.textContent = 'Ab ' + rate;

    button.textContent = '';
    button.appendChild(rateElement);
    button.appendChild(document.createTextNode(' finanzieren'));
    button.dataset.llLabelSwapped = '1';
  }

  /* Logo ans Ende der Zeile: appendChild verschiebt das vorhandene <img> hinter den Text. Bewusst im DOM
     statt per flex-direction, damit Vorlesereihenfolge und Textauswahl der Optik entsprechen. */
  function moveLogoToEnd(wrapper) {
    if (!wrapper || wrapper.dataset.llLogoMoved) return;

    var logo = wrapper.querySelector('.financingLogo');
    if (!logo || !wrapper.querySelector('.rateDetailsText')) return;

    wrapper.appendChild(logo);
    wrapper.dataset.llLogoMoved = '1';
  }

  /* Nur Textknoten aendern: Der Button "hier" in der letzten Zeile traegt den Listener der App und muss bestehen bleiben. */
  function replaceText(element, from, to) {
    if (!element) return;

    Array.prototype.forEach.call(element.childNodes, function (node) {
      if (node.nodeType === 3 && node.nodeValue.indexOf(from) !== -1) {
        node.nodeValue = node.nodeValue.replace(from, to);
      }
    });
  }

  function addressInformally(teaser) {
    replaceText(teaser.querySelector('.cf-pdp-teaser__lead'), 'Finanzieren Sie bequem', 'Finanziere bequem');
    replaceText(teaser.querySelector('.cf-pdp-teaser__more'), 'finden Sie', 'findest du');
  }

  /* <h1 class="modal_title"> -> <p class="modal_title">. Tag tauschen geht nur ueber ein neues Element,
     deshalb Attribute und innerHTML uebernehmen. innerHTML statt textContent, weil im Titel ein <sup>1</sup>
     als Fussnotenverweis steckt. Der Inhalt stammt aus dem App-Embed, nicht aus einer Nutzereingabe. */
  function unheadHeading(heading) {
    if (!heading || heading.tagName !== 'H1' || !heading.parentNode) return;

    var replacement = document.createElement('p');

    for (var i = 0; i < heading.attributes.length; i++) {
      replacement.setAttribute(heading.attributes[i].name, heading.attributes[i].value);
    }

    replacement.innerHTML = heading.innerHTML;
    heading.parentNode.replaceChild(replacement, heading);
  }

  /* Gleiches Verhalten wie der App-Listener: display + .modal-open (die CSS-Klasse macht das Overlay sichtbar). */
  function openCalculator() {
    var modal = document.getElementById('myModal');
    if (!modal) return;

    modal.style.display = 'block';
    modal.classList.add('modal-open');
  }

  function processTree(root) {
    if (!root || root.nodeType !== 1) return;

    /* (3) Heading-Ebene: ueberall, unabhaengig vom Markt. */
    if (root.matches && root.matches(HEADING_SELECTOR)) unheadHeading(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(HEADING_SELECTOR), unheadHeading);
    }

    /* (1) + (2) Label und Logo: nur wo das Widget auch ausgespielt wird. */
    if (!WIDGET_ENABLED) return;

    if (root.matches) {
      if (root.matches(BUTTON_SELECTOR)) swapLabel(root);
      if (root.matches(WRAPPER_SELECTOR)) moveLogoToEnd(root);
      if (root.matches(TEASER_SELECTOR)) addressInformally(root);
    }

    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(BUTTON_SELECTOR), swapLabel);
      Array.prototype.forEach.call(root.querySelectorAll(WRAPPER_SELECTOR), moveLogoToEnd);
      Array.prototype.forEach.call(root.querySelectorAll(TEASER_SELECTOR), addressInformally);
    }
  }

  /* Der komplette Bereich (Logo + Text) oeffnet den Rechner, nicht nur der Button-Textknoten.
     Der App-Listener bleibt aktiv - klickt jemand exakt den Button, laeuft beides, das Oeffnen ist
     aber idempotent. */
  if (WIDGET_ENABLED) document.addEventListener('click', function (event) {
    var container = event.target.closest && event.target.closest(CONTAINER_SELECTOR);
    if (!container || !container.querySelector(BUTTON_SELECTOR)) return;

    event.preventDefault();
    openCalculator();
  });

  /* Das Widget wird erst nach einem API-Call der App eingehaengt, deshalb beobachten statt einmalig lesen. */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) processTree(added[j]);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  processTree(document.body);
})();
